import React, { useState, useRef, memo, useEffect } from "react";
import {
  FlatList,
  View,
  TouchableOpacity,
  Image,
  Platform,
  Dimensions,
} from "react-native";
import { ResizeMode, Video } from "expo-av";
import { BlurView } from "expo-blur";
import dimensions from "../../../../../globalStyles/dimensions";
import { Colors } from "../../../../../globalStyles/ColorConfig";
import ExperienceIcons from "../../../../../assets/Icons/ExperienceIcons";
import { LinearGradient } from "expo-linear-gradient";

const Circle = ({ isActive }: { isActive: boolean }) => (
  <View
    style={{
      height: 8,
      width: 8,
      backgroundColor: isActive ? Colors.black100 : Colors.grey100,
      borderRadius: 50,
      marginHorizontal: 2,
    }}
  />
);
const CarouselPreview = ({ data }: { data: any }) => {
  const [activeIndex, setActiveIndex] = useState(0);
  const flatListRef = useRef<FlatList | null>(null);
  const renderItem = ({ item, index }: { item: string; index: number }) => {
    return (
      <View
        style={{
          backgroundColor: "#fff",
          width: "100%",
          height: "100%",
        }}
      >
        <LinearGradient
          colors={["transparent", "#fff"]}
          style={{
            position: "absolute",
            width:
              Platform.OS === "ios" || Platform.OS === "android"
                ? dimensions.windowWidth
                : 390,
            height:
              Platform.OS === "ios" || Platform.OS === "android"
                ? dimensions.windowHeight / 7
                : 90,
            bottom: 0,
            zIndex: 1,
          }}
        />
        <Image
          source={{ uri: item }}
          style={{
            width:
              dimensions.windowWidth < 500 ? dimensions.windowWidth : "100%",
            height: Platform.OS === "web" ? 500 : "100%",
          }}
        />
      </View>
    );
  };

  const onScroll = (event: any) => {
    const contentOffset = event.nativeEvent.contentOffset.x;
    const currentIndex = Math.round(contentOffset / dimensions.windowWidth);
    setActiveIndex(currentIndex);
  };
  return (
    <>
      <View
        style={{
          height: 500,
          position: "relative",
        }}
      >
        {Array.isArray(data) && data.length && (
          <FlatList
            ref={(ref) => (flatListRef.current = ref)}
            data={data}
            renderItem={renderItem}
            horizontal
            pagingEnabled
            onMomentumScrollEnd={onScroll}
            onScroll={onScroll}
            showsHorizontalScrollIndicator={false}
          />
        )}

        {Array.isArray(data) && data.length > 1 && (
          <View
            style={{
              position: "absolute",
              bottom:
                Platform.OS === "web" ? 0 : dimensions.windowHeight * 0.04,
              overflow: "hidden",
              zIndex: 4,
              paddingHorizontal: 2,
              paddingVertical: 3,
              borderRadius: 50,
              backgroundColor: "rgba(214, 214, 214, 0.9);",
              flexDirection: "row",
              justifyContent: "center",
              alignItems: "center",
              alignSelf: "center",
            }}
          >
            {data.map((_: any, index: number) => (
              <Circle key={index} isActive={index === activeIndex} />
            ))}
          </View>
        )}
      </View>
    </>
  );
};

export default CarouselPreview;
